/* lhx-desc-acordeon.js — UnionX 14/08/2026
   Convierte la descripcion del producto en acordeones dentro de la columna de compra,
   al estilo Lippi. El HTML de las descripciones es sucio (div/br/<b>, casi sin <ul>),
   asi que los titulos NO se buscan por etiqueta sino por forma: un <b>/<strong> corto
   que es TODO el contenido de su bloque. Si no hay ninguno, queda un solo acordeon
   "Descripcion" con el texto entero — nunca se pierde contenido.
   Los nodos se MUEVEN, no se recrean: el texto sigue en el DOM para Google.
   🪤 Se recorren childNodes, NO children: 17 de las 110 fichas traen la descripcion como
   TEXTO SUELTO separado por <br>, sin bloques que lo envuelvan. Recorriendo children uno se
   lleva los <br> y deja todo el texto atras — probado, perdia el 100% en esas 17. */
(function () {
  'use strict';
  var LIMPIA = /^[\s·•\-–—]+|[\s:]+$/g;

  // el nombre del producto repetido en negrita al inicio NO es un titulo de seccion:
  // daria un acordeon llamado igual que la ficha. Se compara sin tildes ni signos.
  function normal(t) {
    return (t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/gi, '').toLowerCase();
  }
  function esNombreDelProducto(txt, titProd) {
    if (!titProd) return false;
    var a = normal(txt), b = normal(titProd);
    if (a.length < 8) return false;
    return a === b || b.indexOf(a) === 0 || a.indexOf(b) === 0;
  }

  // 🪤 Que es una SECCION y que es una viñeta no lo dice el largo: lo dice el NOMBRE.
  // Medido sobre los rotulos que salieron de las 110 fichas, los de verdad se repiten
  // (Caracteristicas 27x, Materiales y confeccion 14x, Especificaciones 8x) y la basura
  // aparece una sola vez: "Rgb", "210 gramos", "2400mah", "Banda de agarre". Sin esta lista
  // las fichas de audio daban 9 acordeones de una linea cada uno.
  // Para sumar una seccion nueva, se agrega su raiz aca.
  var SECCIONES = ['caracteristicas', 'especificaciones', 'materiales', 'atributos', 'composicion',
    'tallas', 'funciones', 'ilustracion', 'medidas', 'dimensiones', 'contenido', 'incluye',
    'cuidados', 'garantia', 'referencia de calce', 'que incluye', 'detalles'];

  function esSeccionConocida(txt) {
    var t = (txt || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9 ]/gi, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
    for (var i = 0; i < SECCIONES.length; i++) if (t.indexOf(SECCIONES[i]) === 0) return true;
    return false;
  }

  function esTitulo(nodo) {
    if (!nodo || nodo.nodeType !== 1) return false;
    var b = nodo.matches('b,strong') ? nodo : nodo.querySelector('b,strong');
    if (!b) return false;
    var todo = (nodo.textContent || '').replace(/\s+/g, ' ').trim();
    var negrita = (b.textContent || '').replace(/\s+/g, ' ').trim();
    if (negrita.length < 3 || negrita.length > 45) return false;
    if (/^[·•\-]/.test(todo)) return false;
    // titulo = la negrita es practicamente todo el bloque (se tolera un ":" suelto)
    return todo.replace(LIMPIA, '') === negrita.replace(LIMPIA, '');
  }

  function titulo(txt) {
    var t = txt.replace(/\s+/g, ' ').replace(LIMPIA, '');
    return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
  }

  function acordeon(rotulo, nodos, abierto) {
    var d = document.createElement('details');
    d.className = 'lhx-acc';
    if (abierto) d.open = true;
    var s = document.createElement('summary');
    s.textContent = rotulo;
    d.appendChild(s);
    var c = document.createElement('div');
    c.className = 'lhx-acc__c';
    nodos.forEach(function (n) { c.appendChild(n); });
    d.appendChild(c);
    return d;
  }

  function construir() {
    var src = document.querySelector('.lhx-src');
    if (!src || src.dataset.lhxListo) return;
    src.dataset.lhxListo = '1';

    // los bloques reales pueden estar un nivel mas abajo si Shopify envolvio todo en un div
    var raiz = src;
    if (src.children.length === 1 && !src.textContent.replace(src.children[0].textContent, '').trim()) raiz = src.children[0];
    var hijos = Array.prototype.slice.call(raiz.childNodes).filter(function (n) {
      return n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim());
    });
    if (!hijos.length) return;

    var titProd = src.getAttribute('data-titulo') || (document.querySelector('h1') || {}).textContent || '';
    var intro = [], secciones = [], actual = null;
    hijos.forEach(function (n) {
      if (n.nodeType === 1 && esTitulo(n) && esSeccionConocida(n.textContent)
          && !esNombreDelProducto(n.textContent, titProd)) {
        actual = { t: titulo(n.textContent), nodo: n, cuerpo: [] }; secciones.push(actual);
      }
      else if (actual) actual.cuerpo.push(n);
      else intro.push(n);
    });

    var tieneTexto = function (ns) { return ns.some(function (n) { return (n.textContent || '').trim(); }); };

    var caja = document.createElement('div');
    caja.className = 'lhx-desc';
    if (tieneTexto(intro)) caja.appendChild(acordeon('Descripción', intro, false));
    secciones.forEach(function (s, i) {
      if (!tieneTexto(s.cuerpo)) return;
      caja.appendChild(acordeon(s.t, s.cuerpo, false));
    });
    if (!caja.children.length) return;   // nada que mostrar: se deja como estaba
    src.replaceWith(caja);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', construir);
  else construir();
  // Horizon re-renderiza la ficha al cambiar de variante (Section Rendering API)
  new MutationObserver(function () { construir(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
